import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Environment, environmentToken } from '@environment';
import { Observable } from 'rxjs';
import { Resource } from '@app/shared/resources/resource';
import { CoordinatesAndTimezone } from '@app/shared/models/building.interface';

@Injectable({
  providedIn: 'root'
})
export class LocationResource extends Resource<string[], string> {
  constructor(protected httpClient: HttpClient, @Inject(environmentToken) environment: Environment) {
    super(httpClient, `${environment.apiUrl + environment.apiPath}/location`);
  }

  getCoordinatesAndTimezoneByCity(country: string, city: string): Observable<CoordinatesAndTimezone> {
    return this.httpClient.get<CoordinatesAndTimezone>(`${this.baseUrl}/coordinates?country=${country}&city=${city}`);
  }

  getCitiesOfCountry(country: string): Observable<string[]> {
    return this.httpClient.get<string[]>(`${this.baseUrl}/cities-for-country?country=${country}`);
  }

  getCountries(): Observable<string[]> {
    return this.httpClient.get<string[]>(`${this.baseUrl}/countries`);
  }
}
